module.exports = __webpack_public_path__ + "static/media/login-background.9e9515db.png";